var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversationNoPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233,
    height: 228.261,
    viewBox: "0 0 233 228.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-965 -397)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(977.036 397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.468,109.245C180.459,75.546,182.8,41,172.19,24.761S129.965-19.483,55.264,29.312s-55.7,101.837-44.028,119.7C65.866,232.642,241.451,168.927,202.468,109.245Z",
    transform: "translate(-0.171 -1.91)",
    fill: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988.535 398.678)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H5.819V11.639H0Z",
    transform: "translate(0 4.114) rotate(-45)",
    fill: "#e7e7f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.639V5.819H0Z",
    transform: "translate(0 8.228) rotate(-45)",
    fill: "#e7e7f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.657 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.639V5.819H0Z",
    transform: "translate(0 8.228) rotate(-45)",
    fill: "#e7e7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.383 142.871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.479,44.208a8.729,8.729,0,1,1,8.729-8.729A8.74,8.74,0,0,1,35.479,44.208Zm0-11.639a2.91,2.91,0,1,0,2.91,2.91A2.914,2.914,0,0,0,35.479,32.569Z",
    transform: "translate(-6.75 -1.75)",
    fill: "#e7e7f2"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.5,
    cy: 9.5,
    rx: 116.5,
    ry: 9.5,
    transform: "translate(965 606.261)",
    fill: "#f5f5f5",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-313.36 17.753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.5,71.5h63.79v77.966H127.5Z",
    transform: "translate(1240.781 359.906)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5,186.834V119.5h63.79v85.053H97.219Z",
    transform: "translate(1278.149 322.538)",
    fill: "#efeff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.219,441.219V423.5H79.5",
    transform: "translate(1278.149 85.872)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1370.948 466.181)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.263,
    cy: 21.263,
    r: 21.263,
    transform: "translate(0 0)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.176,
    cy: 14.176,
    r: 14.176,
    transform: "translate(7.088 7.088)",
    fill: "#efeff8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.015,
    height: 33.912,
    rx: 4.008,
    transform: "translate(28.51 35.666) rotate(-45)",
    fill: "#dfdff0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1386 477.807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.449,272.006a5.174,5.174,0,0,0-3.838,1.435,5.229,5.229,0,0,0-1.61,3.765h3.322a1.883,1.883,0,0,1,1.974-1.881,1.916,1.916,0,0,1,1.789,1.789,1.884,1.884,0,0,1-.78,1.619,6.842,6.842,0,0,0-2.762,5.56h3.322a3.515,3.515,0,0,1,1.387-2.868,5.206,5.206,0,0,0-2.8-9.419Z",
    transform: "translate(-200 -272)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,335.5h3.322v3.544H216Z",
    transform: "translate(-212.456 -321.435)",
    fill: "#dfdff0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.5,168h3.544v3.322H183.5Z",
    transform: "translate(1197.185 284.78)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5,168h3.544v3.322H215.5Z",
    transform: "translate(1172.272 284.78)",
    fill: "#dfdff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.5,168h3.544v3.322H247.5Z",
    transform: "translate(1147.36 284.78)",
    fill: "#dfdff0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationNoPost);
export default __webpack_public_path__ + "static/media/conversation-no-post.8a1e5e8b2c9dd5e93e37563b55ad262e.svg";
export { ForwardRef as ReactComponent };